import script from "./TimingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TimingComponent.vue?vue&type=script&setup=true&lang=js"

import "./TimingComponent.vue?vue&type=style&index=0&id=8f590cf6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f590cf6"]])

export default __exports__